















import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {Grid} from '@toast-ui/vue-grid';
import {appendComma} from '@/utils/viewUtils';

@Component
export default class SmsUsageListDetail extends Vue {
  @Prop({required: true}) readonly data!: object[];
  private gridProps = {
    columns: [
      {
        header: '기간',
        name: 'period',
        align: 'center',
        minWidth: 20
      },
      {
        header: '발송 유형',
        name: 'messageType',
        align: 'center',
        minWidth: 85
      },
      {
        header: '사용량',
        name: 'amount',
        align: 'center',
        minWidth: 85,
        formatter: function(data: any) {
          return appendComma(data.value.toString().split('.')) + ' 건';
        }
      },
      {
        header: '단가',
        name: 'price',
        align: 'center',
        minWidth: 85,
        formatter: function(data: any) {
          return appendComma(data.value.toString().split('.')) + ' 원';
        }
      },
      {
        header: '금액',
        name: 'totalPrice',
        align: 'center',
        minWidth: 85,
        formatter: function(data: any) {
          return appendComma(data.value.toString().split('.')) + ' 원';
        }
      }
    ],
    options: {
      header: {
        height: 33
      },
      columnOptions: {
        minWidth: 50
      },
      minRowHeight: 31,
      rowHeight: 31,
      bodyHeight: 31,
      isInitialRequest: true,
      useClientSort: false,
      copyOptions: {
        useFormattedValue: true
      }
    }
  };

  @Watch('data')
  onDataChanged() {
    (this.$refs.usageDetailGrid as Grid).invoke('resetData', this.data as any);
  }

  private mounted() {
    (this.$refs.usageDetailGrid as Grid).invoke('resetData', this.data as any);
  }
}
